import gql from 'graphql-tag'

const CreateClaimClose = gql`
  mutation CreateClaimClose($input: CreateClaimCloseMutationInput!) {
    createClaimClose(input: $input) {
      claimClose {
        id
        claimId
        reason
        description
      }
    }
  }
`

export { CreateClaimClose }


// WEBPACK FOOTER //
// ./src/mutations/CreateClaimClose.js